import { api } from '@/config/api';

export interface FullCampaignPayload {
  campaign_id: string;
  adset_ids: string[];
  ad_ids: string[];
}

export const facebookMarketingActionsService = {
  activateFullCampaign: async (payload: FullCampaignPayload) =>
    (await api.post('/slighter_crm/facebook/marketing-actions/activate-full-campaign', payload)).data,

  pauseFullCampaign: async (payload: FullCampaignPayload) =>
    (await api.post('/slighter_crm/facebook/marketing-actions/pause-full-campaign', payload)).data,
};
